import React from 'react';

export const TaskAssigneeModal = ({
    isOpen,
    ticket,
    searchTerm,
    setSearchTerm,
    options,
    isSearching,
    error,
    onSelectAssignee,
    onClose,
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Actualizar asignado</h5>
                            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
                        </div>

                        <div className="modal-body">
                            <p className="text-muted mb-2">
                                Ticket: <span className="fw-semibold">{ticket?.code || '-'}</span>
                            </p>

                            <label className="form-label">Buscar usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value || '')}
                                placeholder="Escribe nombre o correo"
                            />

                            <div className="d-flex flex-column gap-2 mt-3 assignee-modal-results">
                                <button
                                    type="button"
                                    className="btn btn-light-brand text-start"
                                    onClick={() => onSelectAssignee('')}
                                >
                                    Sin asignar
                                </button>

                                {isSearching && (
                                    <div className="text-muted fs-12">Buscando usuarios...</div>
                                )}

                                {!isSearching && String(searchTerm || '').trim().length < 2 && (
                                    <div className="text-muted fs-12">Escribe al menos 2 caracteres para buscar usuarios.</div>
                                )}

                                {!isSearching && String(searchTerm || '').trim().length >= 2 && options.length === 0 && (
                                    <div className="text-muted fs-12">No hay usuarios para mostrar.</div>
                                )}

                                {!isSearching && options.map((user) => (
                                    <button
                                        key={user._id}
                                        type="button"
                                        className="btn btn-light-brand text-start assignee-modal-option"
                                        onClick={() => onSelectAssignee(user._id)}
                                    >
                                        <div className="fw-semibold fs-12 text-truncate d-inline-flex align-items-center gap-2">
                                            <i
                                                className={`rounded-circle ${user?.available ? 'bg-success' : 'bg-danger'}`}
                                                style={{ width: '8px', height: '8px', display: 'inline-block' }}
                                            />
                                            <span>{user.name || user.email}</span>
                                        </div>
                                        <div className="text-muted fs-12 text-truncate">{user.email}</div>
                                    </button>
                                ))}
                            </div>

                            {error && (
                                <div className="alert alert-danger py-2 mt-3 mb-0" role="alert">{error}</div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-brand" onClick={onClose}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    );
};